// extracted by mini-css-extract-plugin
module.exports = {"selects":"CurrentMedConditions_selects__1Ulu4"};